import React, { useState, useEffect } from 'react';

// material-ui
import { Grid, Typography } from '@mui/material'

// project imports
import MainCard from 'components/MainCard';
import ReviewsFilter from '../dashboard/ReviewsFilter';
import { fetchReviewsData, fetchSentimentAnalyticsData, getDefaultDateRange, handleExportClick } from '../../utils/helper';

import SentimentAnalyticsCard from '../../components/cards/statistics/SentimentAnalyticsCard';
import ReviewAnalyticsCard from '../../sections/dashboard/default/ReviewAnalyticsCard';
import SentimentOvertimeChart from '../../sections/dashboard/sentiment/SentimentOvertimeChart';
import TopThemeSentimentTable from '../../sections/sentimentAnalytics/TopThemeSentimentTable';
import RecentPositiveKeywords from '../../sections/sentimentAnalytics/RecentPositiveKeywords';
import RecentNegativeKeywords from '../../sections/sentimentAnalytics/RecentNegativeKeywords';
import SentimentAnalyticLineChart from '../../sections/sentimentAnalytics/SentimentAnalyticLineChart';
import SentimentAnalyticPieChart from '../../sections/sentimentAnalytics/SentimentAnalyticPieChart';
// ==============================|| SentimentAnalytics PAGE ||============================== //

const formatSigned = (v) => {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n) || n === 0) return "0"; // or "+0" if you prefer
  return n > 0 ? `+${n}` : `${n}`; // negative already has '-'
};

export default function SentimentAnalytics() {
  const [reviewsData, setReviewsData] = useState(null)
  const [sentimentAnalyticsData, setSentimentAnalyticsData] = useState(null)
  const defaultDateRange = getDefaultDateRange();
  // useEffect(() => {
  //   fetchReviewsData("", "", "", defaultDateRange, setReviewsData);
  // }, []);
  useEffect(() => {
    fetchSentimentAnalyticsData("", "", "", "", defaultDateRange, setSentimentAnalyticsData);
  }, []);

  const handleFilterApply = (selectedCountry, selectedLocation, selectedCompany, selectedSource, selectedDate) => {
    fetchSentimentAnalyticsData(selectedCountry, selectedLocation, selectedCompany, selectedSource, selectedDate, setSentimentAnalyticsData);
  }

  const onExportClick = (exportType = 'csv') => {
    handleExportClick(exportType, sentimentAnalyticsData?.data?.reviews, 'reviews_export');
  }


  const handleFilterClear = () => {
    fetchSentimentAnalyticsData("", "", "", "", defaultDateRange, setSentimentAnalyticsData);
  }


  return (

    <>
      <MainCard title="Review Filter" sx={{ mb: 3 }}>
        <ReviewsFilter onFilterApply={handleFilterApply} defaultDateRange={defaultDateRange} onExportClick={onExportClick} onFilterClear={handleFilterClear} />
      </MainCard>
      <Grid container rowSpacing={4.5} columnSpacing={2.75} sx={{ mb: 3 }}>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <SentimentAnalyticsCard variant="sentiment" title="Overall Sentiment" value={sentimentAnalyticsData?.totalPositive} trend={formatSigned(sentimentAnalyticsData?.posDifference)} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <SentimentAnalyticsCard variant="rating" title="Avg. Rating" value={sentimentAnalyticsData?.averageStarRating} trend={formatSigned(sentimentAnalyticsData?.avgDifference)} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <SentimentAnalyticsCard variant="volume" title="Review Volume" value={sentimentAnalyticsData?.totalReviews} trend={formatSigned(sentimentAnalyticsData?.reviewsDifference)} color="error" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <SentimentAnalyticsCard variant="critical" title="Critical Reviews" value={38} trend="-7%" color="warning" />
        </Grid>
      </Grid>
      <Grid sx={{ display: { sm: 'none', md: 'block', lg: 'none' } }} size={{ md: 12 }} />

      <Grid container rowSpacing={4.5} columnSpacing={2.75}>
        <Grid size={{ xs: 12, md: 7, lg: 7 }}>
          <SentimentAnalyticLineChart sentimentAnalyticsData={sentimentAnalyticsData} />
        </Grid>
        <Grid size={{ xs: 12, md: 7, lg: 5 }}>
          <SentimentAnalyticPieChart pieSentimentAnalyticsData={sentimentAnalyticsData} />
        </Grid>
      </Grid>

      <Grid sx={{
        margin: "24px 0"
      }}>
        <TopThemeSentimentTable tableData={sentimentAnalyticsData} />

      </Grid>


      <Grid container rowSpacing={4.5} columnSpacing={2.75}>
        <Grid size={{ xs: 12, md: 7, lg: 7 }}>
          <RecentPositiveKeywords data={sentimentAnalyticsData} />
        </Grid>
        <Grid size={{ xs: 12, md: 7, lg: 5 }}>
          <RecentNegativeKeywords data={sentimentAnalyticsData} />
        </Grid>
      </Grid>
    </>

  );
}
